/* eslint-disable */
const VendorsReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case 'FETCH_PRODUCT_SUCCESS':
      var { vendor: { id: vendorId, logoUrl: imageUrl, ...rest } } = action.payload.data;
      return {
        ...state,
        [vendorId]: {
          imageUrl,
          ...rest,
        },
      };
    case 'FETCH_SEARCH_SUCCESS':
      var hotVendors = action.payload.data.vendors.reduce((vendors, currentVendor) => {
        const { id: vendorId, quantity: _, ...rest } = currentVendor;
        return {
          ...vendors,
          [vendorId]: rest,
        };
      }, {});

      return { ...state, ...hotVendors };
    default: return state;
  }
};

export default VendorsReducer;
